import { useStaticData } from "@clinic/shared/hooks/useStaticData/useStaticData";

const useFSWholesaleEnabled = () => useStaticData().fsWholesaleEnabled;

export { useFSWholesaleEnabled };
